export function PreSaleFlag() {
  return (
    <div className="p-[6px] font-medium text-xs text-white bg-primaryBlue">
      Pré-venda
    </div>
  )
}
